import methods from "./methods";

export default {
  getAccessToken: () => {
    return localStorage.getItem("accessToken");
  },

  setCredentials: (
    accessToken,
    refreshToken,
    brandID,
    fullName,
    avatar,
    brandName,
    logo
  ) => {
    localStorage.setItem("accessToken", accessToken);
    localStorage.setItem("refreshToken", refreshToken);
    localStorage.setItem("Brand-ID", brandID);
    localStorage.setItem("UserName", fullName);
    localStorage.setItem("Avatar", avatar);
    localStorage.setItem("Brand-Name", brandName);
    localStorage.setItem("Brand-Logo", logo);
  },

  getCredentials: () => {
    return {
      brandID: localStorage.getItem("Brand-ID"),
      fullName: localStorage.getItem("UserName"),
      avatar: localStorage.getItem("Avatar"),
      brandName: localStorage.getItem("Brand-Name"),
      brandLogo: localStorage.getItem("Brand-Logo"),
    };
  },

  removeCredentials: () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("Brand-ID");
    localStorage.removeItem("UserName");
    localStorage.removeItem("Avatar");
    localStorage.removeItem("Brand-Name");
    localStorage.removeItem("Brand-Logo");
  },
};
